export const getFileArray = (file): Promise<string | ArrayBuffer> => {
  return new Promise<string | ArrayBuffer>((acc, err) => {
    const reader = new FileReader()
    reader.onload = (event) => {
      acc(event.target.result)
    }
    reader.onerror = (error) => {
      err(error)
    }
    reader.readAsArrayBuffer(file)
  })
}

export const upload = async ({ putUrl, file }: { putUrl: string; file: HTMLInputElement }) => {
  return await fetch(putUrl, {
    method: 'PUT',
    headers: {
      'Content-type': file['type'],
    },
    body: await getFileArray(file),
  })
}

export default upload
